"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _notificationsMiddleware = _interopRequireDefault(require("./notificationsMiddleware"));

var _default = [_notificationsMiddleware.default];
exports.default = _default;
module.exports = exports.default;